<script lang="ts">
  import { defineComponent } from 'vue';
  import Mixins from '@/helpers/mixins';
  import { StatusBarStyles } from '@/helpers/enums';

  export default defineComponent({
    mixins: [Mixins],
    created(): void {
      this.updateStatusBarStyle(StatusBarStyles.dark_content);
    },
    beforeUpdate(): void {
      this.updateStatusBarStyle(StatusBarStyles.dark_content);
    },
  });
</script>

<template>
  <div class="layout--wrapper sub-page-layout--wrapper">
    <RouterView v-slot="{ Component }">
      <Component :is="Component" />
    </RouterView>
  </div>
</template>
